import {useAuth0} from "@auth0/auth0-react";

interface PreviewOnlyProps {
    children: any;
}

function PreviewOnly({children}: PreviewOnlyProps) {
    const {
        isAuthenticated,
        user
    } = useAuth0();


    return isAuthenticated && user?.nickname === "Julian" ? children : null;
}

export default PreviewOnly;